function decodeHtml(value) {
  return String(value || "")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;|&apos;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
}

function emailAddress(value) {
  const text = decodeHtml(value);
  const angled = text.match(/<([^>]+)>/);
  return (angled ? angled[1] : text).trim().toLowerCase();
}

function normalizeSubject(value) {
  return decodeHtml(value)
    .replace(/<[^>]+>/g, "")
    .replace(/[’‘]/g, "'")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

function nyStamp(value) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const pick = (type) => {
    const part = parts.find((item) => item.type === type);
    return part ? part.value : "";
  };
  let hour = pick("hour");
  if (hour === "24") hour = "00";
  return `${pick("year")}-${pick("month")}-${pick("day")}T${hour}:${pick("minute")}`;
}

function parseBriefEmailItem(liHtml) {
  const mailto = String(liHtml || "").match(/href="mailto:([^"]+)"/i);
  if (!mailto) return null;
  const from = emailAddress(decodeURIComponent(mailto[1]));
  if (!from) return null;
  const subjectMatch = String(liHtml).match(/<em>([\s\S]*?)<\/em>/i);
  const subject = subjectMatch
    ? decodeHtml(subjectMatch[1].replace(/<[^>]+>/g, "")).trim()
    : "";
  const calendar = String(liHtml).match(/href="#calendar-(\d+)-(\d+)-(\d+)"/i);
  const time = String(liHtml).match(/(\d{1,2}):(\d{2})\s*([AP]M)/i);
  let when = "";
  if (calendar && time) {
    let hour = Number(time[1]) % 12;
    if (time[3].toUpperCase().startsWith("P")) hour += 12;
    const month = String(calendar[1]).padStart(2, "0");
    const year = calendar[2];
    const day = String(calendar[3]).padStart(2, "0");
    when = `${year}-${month}-${day}T${String(hour).padStart(2, "0")}:${time[2]}`;
  }
  return { from, subject, when };
}

function briefEmailHref(item) {
  const params = new URLSearchParams();
  params.set("openFrom", item.from);
  if (item.subject) params.set("openSubject", item.subject);
  if (item.when) params.set("openWhen", item.when);
  return `/quickemail?${params.toString()}`;
}

function htmlAttr(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;");
}

function rewriteEmailListItem(liHtml) {
  const item = parseBriefEmailItem(liHtml);
  if (!item) return liHtml;
  let replaced = false;
  return String(liHtml).replace(/<a href="mailto:[^"]+">/i, (full) => {
    if (replaced) return full;
    replaced = true;
    return `<a class="pixie-email-link" href="${htmlAttr(briefEmailHref(item))}" title="Open in Quick Email">`;
  });
}

function rewritePixieDailyEmailLinks(html) {
  return String(html || "").replace(
    /(<h2\b[^>]*>[\s\S]*?<\/h2>)([\s\S]*?)(?=<h2\b[^>]*>|$)/gi,
    (full, heading, section) => {
      const title = heading.replace(/<[^>]+>/g, "");
      if (!/\bemail\b/i.test(title)) return full;
      const rewritten = section.replace(
        /<li>([\s\S]*?)<\/li>/gi,
        (listItem, inner) => `<li>${rewriteEmailListItem(inner)}</li>`,
      );
      return heading + rewritten;
    },
  );
}

function newestEmail(rows) {
  return rows.slice().sort((a, b) => {
    const ta = new Date(a.sentOn || 0).getTime() || 0;
    const tb = new Date(b.sentOn || 0).getTime() || 0;
    if (tb !== ta) return tb - ta;
    return (Number(b.id) || 0) - (Number(a.id) || 0);
  })[0];
}

function matchBriefEmail(emails, query) {
  const from = emailAddress(query && query.from);
  if (!from) return null;
  const subject = normalizeSubject(query && query.subject);
  const when = String((query && query.when) || "").trim();
  const rows = (emails || []).filter((row) => emailAddress(row && row.from) === from);
  if (!rows.length) return null;
  if (subject && when) {
    const exact = rows.filter(
      (row) =>
        nyStamp(row.sentOn) === when &&
        normalizeSubject(row.subject) === subject,
    );
    if (exact.length) {
      const original = exact.find(
        (row) => !normalizeSubject(row.subject).startsWith("fwd:"),
      );
      return original || exact[0];
    }
    const sameMinute = rows.filter((row) => nyStamp(row.sentOn) === when);
    if (sameMinute.length === 1) return sameMinute[0];
    return null;
  }
  if (when) {
    const sameMinute = rows.filter((row) => nyStamp(row.sentOn) === when);
    if (sameMinute.length === 1) return sameMinute[0];
  }
  return newestEmail(rows);
}

module.exports = {
  rewritePixieDailyEmailLinks,
  matchBriefEmail,
  nyStamp,
};
